export const getColorForScore = (score) => {
  if (score >= 80) return "#4CAF50";
  if (score >= 60) return "#FFA726";
  return "#EF5350";
};

export function roundToHalf(num) {
  const intPart = Math.floor(num);
  const decimal = num - intPart;

  if (decimal === 0) {
    return intPart; // whole number, no rounding needed
  }

  if (decimal <= 0.5) {
    return intPart + 0.5; // e.g. 8.25 -> 8.5, 8.5 -> 8.5
  }

  return intPart + 1; // e.g. 8.65 -> 9
}

export const calculatePosition = (angle, radius) => {
  const radian = (angle * Math.PI) / 180;
  return {
    x: radius * Math.cos(radian),
    y: radius * Math.sin(radian),
  };
};

export const generateArrowPath = (startX, startY, endX, endY) => {
  const dx = endX - startX;
  const dy = endY - startY;
  const angle = Math.atan2(dy, dx);
  const arrowLength = 15;

  const arrowPoint1 = {
    x: endX - arrowLength * Math.cos(angle - Math.PI / 6),
    y: endY - arrowLength * Math.sin(angle - Math.PI / 6),
  };
  const arrowPoint2 = {
    x: endX - arrowLength * Math.cos(angle + Math.PI / 6),
    y: endY - arrowLength * Math.sin(angle + Math.PI / 6),
  };

  return `M ${startX} ${startY} L ${endX} ${endY} L ${arrowPoint1.x} ${arrowPoint1.y} M ${endX} ${endY} L ${arrowPoint2.x} ${arrowPoint2.y}`;
};
